<template>
  <div>
    <template v-if="msgType == 5">
      <!-- 风险登记提醒 -->
      <risk-msg-dialog :list="list" @handleNavigateRegistration="handleNavigateRegistration" />
    </template>
    <template v-if="msgType == 8">
      <!-- 药师认证审核提醒 -->
      <per-msg-dialog :list="list" @handleNavigatePer="handleNavigatePer" />
    </template>
    <template v-if="msgType == 99 || msgType == 3 || msgType == 6 || msgType == 10">
      <!-- 日报 -->
      <daily-msg-dialog
        :msgType="msgType"
        :messageTime="messageTime"
        :list="list"
        @handleNavigate="handleNavigate"
        @handleNavigateAlarm="handleNavigateAlarm"
        @handleNavigateStore="handleNavigateStore"
      />
    </template>
  </div>
</template>

<script>
/**
 * @description 消息体组件
 *
 * 以下为props
 * @param {Number} msgType  99 销售匹配日报 3 小程序登记 5. 单个登记风险 6. 药品维度展示
 * @param {number} classify {messageDataList.classify} 1.四类 2.特殊 3.处方
 *
 */
import router from '@/router';
import riskMsgDialog from './riskMsgDialog.vue';
import dailyMsgDialog from './dailyMsgDialog.vue';
import perMsgDialog from './perMsgDialog.vue';

export default {
  components: {
    riskMsgDialog,
    dailyMsgDialog,
    perMsgDialog
  },
  props: ['msgType', 'messageTime', 'messageDataList', 'setHasUnRead', 'onKnow'],
  computed: {
    list() {
      let arr = [];
      if (Array.isArray(this.messageDataList)) {
        this.messageDataList.map(item => {
          try {
            arr.push(JSON.parse(item));
          } catch (err) {}
        });
      }
      console.log(arr);
      return arr;
    }
  },

  methods: {
    handleNavigateStore() {
      this.pageTo('/inventory-supervision-stock');
    },
    handleNavigateAlarm() {
      this.pageTo('/prescription-supervision', { riskType: 1 });
    },
    handleNavigatePer(item) {
      const { drugName, orderId } = item;
      this.pageTo('/supervision-prescription-order', { drugName, orderId });
    },
    handleNavigateRegistration(registrationId) {
      this.pageTo('/registration-list-nar/special-detail', { id: registrationId });
    },
    async handleNavigate(type) {
      this.setHasUnRead && this.setHasUnRead();
      // type 1 四类 2特殊 3 处方药
      let path = '';
      if (this.msgType == 3 || this.msgType == 10) {
        if (type == 1) {
          path = '/registration-list-epi';
        }
        if (type == 2) {
          path = '/registration-list-nar';
        }
        if (type == 3) {
          path = '/prescription-supervision';
        }
      } else {
        if (type == 1) {
          path = '/supervision-order';
        }
        if (type == 2) {
          path = '/supervision-special-order';
        }
        if (type == 3) {
          path = '/supervision-prescription-order';
        }
      }

      this.pageTo(path, { messageTime: this.messageTime });
    },
    pageTo(path, query = {}) {
      router.push({ path, query }).catch(err => {
        console.log(err);
      });
      if (this.onKnow) this.onKnow();
      if (this.$myMessageBox) {
        this.$myMessageBox.close();
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.head {
  margin-bottom: 24px;
}
.title {
  font-size: 14px;
  font-weight: bold;
}
.content {
  color: #333;
  font-size: 14px;
  line-height: 28px;
  margin-bottom: 12px;
  // text-align: left;
}
.box-content {
  display: flex;
  max-width: 390px;
}
.box-item {
  min-width: 70px;
}
.num {
  font-weight: 600;
}
.color1 {
  color: #262626;
}
.color2 {
  color: #1e8dff;
}
.color3 {
  color: #ff4e47;
}
.left {
  text-align: left;
}
.color4 {
  color: #ff8200;
}
</style>
